//
//
//
//

import { QINIU_SERVER } from '../../config'

export default {
  name: 'QiniuImg',
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
    },
    Class: {
      type: String,
    },
  },
  computed: {
    qiniuImgUrl() {
      return `${QINIU_SERVER}${this.src}`
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/QiniuImg.vue